import React from 'react';
import { useLocation } from 'react-router-dom';
import { ITranslations } from '../../../i18n/config';
import EmailVerifyMessage from './EmailVerifyMessage';

interface EmailVerifyErrorProps {}

const EmailVerifyError: React.FC<EmailVerifyErrorProps> = () => {
  const { pathname } = useLocation();
  const copyIdentifier = React.useMemo(
    () => (pathname.indexOf('toevoegen') > 0 ? 'add' : 'update'),
    [pathname],
  );

  return (
    <EmailVerifyMessage
      type="danger"
      pageTitle={`accessKeys.email.${copyIdentifier}.title` as ITranslations}
      pageDescription={`accessKeys.email.${copyIdentifier}.intro` as ITranslations}
      title={`accessKeys.verify.error.${copyIdentifier}.title` as ITranslations}
      summary={`accessKeys.verify.error.${copyIdentifier}.summary` as ITranslations}
      body="accessKeys.verify.error.body"
    />
  );
};

export default EmailVerifyError;
